import React from 'react'
import { useForm } from '../forms/useForm';
import { useState, useEffect } from 'react';
import { LostConnection } from '../../constant';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { useHistory } from 'react-router-dom';
import { validarSesion } from '../../hooks/tokens/useToken';
import { usePagination } from '../pagination/usePagination';
import { ConfigServer } from '../../data/config';



export const useLaboratories = () => {

    const history = useHistory();

    const [externalLaboratory, setExternalLaboratory] = useState([]);
    const [externalLaboratoryId, setExternalLaboratoryId] = useState(0);

    const [states, setStates] = useState({});
    const [municipalities, setMunicipalities] = useState({});

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const [loadingExport, setLoadingExport] = useState(false);
    const [reportExternalLaboratory, setReportExternalLaboratory] = useState([]);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [searchExternal, setSearchExternal] = useState("");


    useEffect(() => {

        getExternalLaboratories();

    }, [history.location])


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        id_external_laboratory: 0,
        id_state: 0,
        id_municipality: 0,
        name_state: "",
        name_municipality: "",
        code: "",
        name: "",
        business_name: "",
        rfc: "",
        phone: "",
        address: "",
        colony: "",
        cp: 0,
        email: "",
        web_site: ""
    });


    const { id_external_laboratory, id_state, id_municipality, name_state, name_municipality, code,
        name, business_name, rfc, phone, address, colony, cp, email, web_site } = formValues;


    const [validaciones, SetValidaciones] = useState({
        id_state_valid: false,
        id_municipality_valid: false,
        code_valid: false,
        name_valid: false,
        business_name_valid: false,
        rfc_valid: false,
        address_valid: false,
        colony_valid: false,
        cp_valid: false,
        email_valid: false,
    });


    const toggle = () => {
        setModal(prev => !prev);
    }

    const closeModaLaboratories = () => {
        setModal(false);
    };


    const handleCreate = () => {

        handleUpdateValues({
            id_external_laboratory: 0,
            id_state: 0,
            id_municipality: 0,
            name_state: "",
            name_municipality: "",
            code: "",
            name: "",
            business_name: "",
            rfc: "",
            phone: "",
            address: "",
            colony: "",
            cp: 0,
            email: "",
            web_site: ""
        });

        SetValidaciones({
            id_state_valid: false,
            id_municipality_valid: false,
            code_valid: false,
            name_valid: false,
            business_name_valid: false,
            rfc_valid: false,
            address_valid: false,
            colony_valid: false,
            cp_valid: false,
            email_valid: false,
        })

        setExternalLaboratoryId(0);
        setMethod("create");
        setModalTitle("Registrar un nuevo Laboratorio Externo");
        getState();
        toggle();
    }

    const numberItems = 10;

    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(externalLaboratory.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listExternal = [];
        externalLaboratory.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listExternal.push({
                ...data,
                visibleTable: visibleTable
            });
        });

       setExternalLaboratory(listExternal);

    }, [totalPageCount, currentPage]);







    const getExternalLaboratories = async () => {

        let requestOptions = {
            method: 'GET'
        };

        //let ListLaboratories = [];

        const respuesta = await sendRequest(requestOptions, "ExternalLaboratories/List");

        if (respuesta.code === 200) {

            if (respuesta.data.length >= 1) {
      
                let ListLaboratories = [];
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;

                endItems = aux;
                startItems = endItems - numberItems;


                respuesta.data.forEach((value,index) => {

                    let posicion = index + 1;
                    let visibleTable = false;
        
                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    ListLaboratories.push({
                        id_external_laboratory: value.id_external_laboratory,
                        id_state: value.id_state,
                        id_municipality: value.id_municipality,
                        name_state: value.name_state,
                        name_municipality: value.name_municipality,
                        code: value.code,
                        name: value.name,
                        business_name: value.business_name,
                        rfc: value.rfc,
                        phone: value.phone,
                        address: value.address,
                        colony: value.colony,
                        cp: value.cp,
                        email: value.email,
                        web_site: value.web_site,
                        visibleTable:visibleTable
                    });
                });
                setExternalLaboratory(ListLaboratories);
                setEsternalData(ListLaboratories)
            }
            else {
                createSweet("error", "warning", "Hubo un error!", "No se encontraron los laboratorios");
                setExternalLaboratory([]);
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getExternalLaboratories);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Laboratorios Externos", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "laboratorios Externos", respuesta.data.msg);
        }
      
    }


    const getState = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "State/List");

        if (respuesta.code === 200) {
            setStates(respuesta.data);
            //////console.log(respuesta.data);
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getState);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Laboratorios Externos", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Laboratorios Externos", respuesta.data.msg);

        }
   
    }


    const getMunicipality = async (id_state) => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, `Municipality/List/${id_state}`);

        if (respuesta.code === 200) {
            setMunicipalities(respuesta.data);
            //////console.log(respuesta.data);
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getMunicipality);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Laboratorios Externos", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Laboratorios Externos", respuesta.data.msg);

        }
     
    }


    const saveCreate = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mData = formValues;

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(mData)
        };

        const respuesta = await sendRequest(requestOptions, "ExternalLaboratories/Create");
        if (respuesta.code === 200) {

            getExternalLaboratories();
            reset();
            createSweet("create", "success", "Exito!", "Laboratorio externo creado");
            setLoading(false);
            closeModaLaboratories();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Laboratorios Externos", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Laboratorios Externos", respuesta.data.msg);
            //setLoading(false);

        }
        // else {
        //     createSweet("error", "error", "Hubo un error!", LostConnection);
        // }
    }


    const handleChangeState = (e) => {
        handleInputChange(e);

        let mValue = e.target.value;

        getMunicipality(mValue);
    }


    const handleUpdate = (id_external_laboratory) => {

        let laboratory = externalLaboratory.find(b => b.id_external_laboratory === parseInt(id_external_laboratory));

        handleUpdateValues({
            id_state: laboratory.id_state,
            id_municipality: laboratory.id_municipality,
            name_state: laboratory.name_state,
            name_municipality: laboratory.name_municipality,
            code: laboratory.code,
            name: laboratory.name,
            business_name: laboratory.business_name,
            rfc: laboratory.rfc,
            phone: laboratory.phone,
            address: laboratory.address,
            colony: laboratory.colony,
            cp: laboratory.cp,
            email: laboratory.email,
            web_site: laboratory.web_site
        });
        getState();
        getMunicipality(laboratory.id_state);
        setExternalLaboratoryId(id_external_laboratory);
        setMethod("update");
        setModalTitle("Modificar laboratorio");
        toggle();
    }


    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }


        let body = {
            id_external_laboratory: externalLaboratoryId,
            ...{ ...formValues }
        };

        let requestOptions = {
            method: 'PUT',
            body: JSON.stringify(body)
        };

        const respuesta = await sendRequest(requestOptions, "ExternalLaboratories/Update");

        if (respuesta.code === 200) {
            getExternalLaboratories();
            createSweet("create", "info", "Exito!", "Laboratorio actualizado");
            setLoading(false);
            closeModaLaboratories();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Laboratorios Externos", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Laboratorios Externos", respuesta.data.msg);
            //setLoading(false);

        }
        // else {
        //     createSweet("error", "error", "Hubo un error!", LostConnection);
        //     setLoading(false);
        //     validarSesion(history, saveUpdate);
        // }
    }



    const handleDelete = (id_external_laboratory) => {
        let laboratory = externalLaboratory.find(b => b.id_external_laboratory === parseInt(id_external_laboratory));


        handleUpdateValues({
            code: laboratory.code,
            name: laboratory.name
        });
        setExternalLaboratoryId(id_external_laboratory);
        setMethod("delete");
        setModalTitle("Eliminar laboratorio");
        toggle();

    }


    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };
        const respuesta = await sendRequest(requestOptions, `ExternalLaboratories/${externalLaboratoryId}`);

        if (respuesta.code === 200) {
            getExternalLaboratories();
            setLoading(false);
            createSweet("create", "info", "Exito!", "Laboratorio eliminado");
            closeModaLaboratories();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Laboratorios Externos", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Laboratorios Externos", respuesta.data.msg);
            setLoading(false);

            //setLoading(false);

        }


        // else {
        //     createSweet("error", "error", "Hubo un error!", LostConnection);
        //     setLoading(false);
        //     validarSesion(history, saveDelete);
        // }
    }

    
    const [esternalData, setEsternalData] = useState([]);

    
    const handleSearchExternal = (value) => {
        setSearchExternal(value);

        let busqueda = value;
        let newMethod = [];

        const safeToUpper = (val) => (typeof val === "string" ? val.toUpperCase() : "");

        esternalData.forEach(element => {
            let cadena = safeToUpper(element.name);
            let code = safeToUpper(element.code);
            let business_name = safeToUpper(element.business_name);
            let rfc = safeToUpper(element.rfc);
            let email = safeToUpper(element.email);

            if (
                cadena.includes(busqueda.toUpperCase()) ||
                code.includes(busqueda.toUpperCase()) ||
                business_name.includes(busqueda.toUpperCase()) ||
                rfc.includes(busqueda.toUpperCase()) ||
                email.includes(busqueda.toUpperCase())
            ) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setExternalLaboratory(newMethod);
    };

    const handleClearExternal = () => {
        setSearchExternal("");
        localStorage.removeItem("globalFilter");
        setExternalLaboratory(esternalData);
    };


    // ? DOWNLOAD CSV
    const downloadExcel = async (rateId) => {
        let token = localStorage.getItem("token");
        //ExternalLaboratories/ExternalLaboratoryDownload/1
        await fetch(ConfigServer.serverUrl + `/api/ExternalLaboratories/ExternalLaboratoryDownload/${rateId}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se descargo el archivo excel");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Laboratorios_Externos.xlsx");

                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }








    const validarForm = () => {

        let statusValidacion = false;
        let newValidaciones = {};

        const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (formValues.id_state === "-1" || formValues.id_state === 0) {
            newValidaciones = {
                ...newValidaciones,
                id_state_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                id_state_valid: false
            };
        }

        if (formValues.id_municipality === "-1" || formValues.id_municipality === 0) {
            newValidaciones = {
                ...newValidaciones,
                id_municipality_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                id_municipality_valid: false
            };
        }


        if (formValues.code.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                code_valid: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                code_valid: false
            };
        }


        if (formValues.email === "") {
            newValidaciones = {
                ...newValidaciones,
                email_valid: false
            };
        }
        else {
            if (!pattern.test(formValues.email)) {
                newValidaciones = {
                    ...newValidaciones,
                    email_valid: true
                };
                statusValidacion = true;
            }
            else {
                newValidaciones = {
                    ...newValidaciones,
                    email_valid: false
                };
            }
        }


        if (formValues.name.length <= 0) {
            newValidaciones = {
                ...newValidaciones,
                name_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                name_valid: false
            };
        }


        if (formValues.business_name.length <= 0) {
            newValidaciones = {
                ...newValidaciones,
                business_name_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                business_name_valid: false
            };
        }


        if (formValues.rfc.length <= 0) {
            newValidaciones = {
                ...newValidaciones,
                rfc_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                rfc_valid: false
            };
        }


        if (formValues.address.length <= 0) {
            newValidaciones = {
                ...newValidaciones,
                address_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                address_valid: false
            };
        }


        if (formValues.colony.length <= 0) {
            newValidaciones = {
                ...newValidaciones,
                colony_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                colony_valid: false
            };
        }


        if (parseInt(formValues.cp) <= 0) {
            newValidaciones = {
                ...newValidaciones,
                cp_valid: true
            };
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                cp_valid: false
            };
        }

        SetValidaciones(newValidaciones);

        return statusValidacion;

    }

    const navigateUpdate = (id_external_laboratory) => {
        history.push(`../catalogos/${id_external_laboratory}/asignar-examen`);

    }


    // #region Excel

    const handleExportExcelLaboratory = async () => {
        setLoadingExport(true);

            const XLSX = await import("xlsx");

            const _report = externalLaboratory.map(laboratory => ({
                Código: laboratory.code ?? "---",
                Nombre: laboratory.name ?? "---",
                Razón_Social: laboratory.business_name ?? "---",
                RFC: laboratory.rfc ?? "---",
                Teléfono: laboratory.phone ?? "---",
                Correo: laboratory.email ?? "---",
                Dirección: laboratory.address ?? "---",
                ColonIa: laboratory.colony ?? "---",
                Estado: laboratory.name_state ?? "---",
                Municipio: laboratory.name_municipality ?? "---",
                CP: laboratory.cp ?? "---",
                
              
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Listado_Laboratorio_externo.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

       

        setLoadingExport(false);
    };

    //#endregion


    //#region
    const downloadReport = async () => {
        try {
            setLoadingDownload(true); 

            const response = await fetch("/api/ExternalLaboratories/DownloadReport", {
                method: "POST",
            });

            if (!response.ok) {
                const errorData = await response.json();
                createSweet("error", "warning", "Laboratorios Externos", errorData.msg);
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte_laboratorios_externos.xlsx");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

        } catch (error) {
            console.error(error);
            createSweet("error", "warning", "Laboratorios Externos", "Ocurrió un error al descargar el reporte.");
        } finally {
            setLoadingDownload(false);
        }
    };

    //#endregion



    return {

        toggle, modal, modalTitle, handleCreate, saveCreate, externalLaboratory, method, loading,
        handleDelete, handleUpdate, handleInputChange, validaciones,
        id_external_laboratory, id_state, id_municipality, name_state, name_municipality, code,
        name, business_name, rfc, phone, address, colony, cp, email, web_site,
        states, municipalities, handleChangeState, saveDelete, saveUpdate,
        navigateUpdate,
        totalPageCount, currentPage, nextPage, previousPage, goToPage,handleSearchExternal,
        downloadExcel, handleExportExcelLaboratory, loadingExport,
        reportExternalLaboratory, downloadReport, loadingDownload, closeModaLaboratories,
        handleClearExternal, searchExternal


    }
}
